import React, { useEffect, useState } from "react";
import { api, API } from "@/lib/api";

// Fetches a protected receipt image as a blob and renders it. Applies zoom/rotate/brightness.
export function ReceiptImage({ path, zoom = 1, rotate = 0, brightness = 100, className = "" }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let url;
    let active = true;
    (async () => {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        if (!active) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      } catch {
        setErr(true);
      }
    })();
    return () => { active = false; if (url) URL.revokeObjectURL(url); };
  }, [path]);

  if (err) return <div className="text-xs text-muted-foreground p-4">Gagal memuat foto</div>;
  if (!src) return <div className="animate-pulse bg-secondary w-full h-full min-h-[200px] rounded" />;

  return (
    <img
      src={src}
      alt="Foto nota"
      className={className}
      style={{
        transform: `scale(${zoom}) rotate(${rotate}deg)`,
        filter: `brightness(${brightness}%) contrast(${brightness > 100 ? 110 : 100}%)`,
        transition: "transform 0.15s ease",
      }}
    />
  );
}

export function ReceiptThumb({ path, className = "" }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url; let active = true;
    (async () => {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        if (!active) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      } catch {}
    })();
    return () => { active = false; if (url) URL.revokeObjectURL(url); };
  }, [path]);
  if (!src) return <div className={`animate-pulse bg-secondary ${className}`} />;
  return <img src={src} alt="thumb" className={className} />;
}
